import { atom } from "recoil";

const authAtom = atom({
  key: "authAtom",
  default: localStorage.getItem("boomviber-auth")
    ? JSON.parse(localStorage.getItem("boomviber-auth"))
    : null,
});

export default authAtom;
